import { isMobile } from '@zorba-shared/client/Services/clientService';
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { Tabs, Tag } from 'antd';
import { PROPERTY_TYPE_LOT } from '@zorba-shared/core/Constants/deal';

import { DEAL_SUBMISSION_MATCH_STATUS_TITLES } from '@zorba-shared/core/Constants/offer';
import Modal from '../../../../components/layout/Modal';
import { setSelectedOffer } from '../../../../reducers/Offer/actions';
import PropertyDetailsTab from './Components/PropertyDetailsTab';
import ActivityTab from './Components/ActivityTab';

import './index.scss';
import { reportEvent } from '../../../../services/analyticsService';

export default ({ type = '' }) => {
  const { selectedOffer } = useSelector(({ OfferReducer }) => OfferReducer);
  const { organization, userDetails } = useSelector(
    ({ AuthReducer }) => AuthReducer,
  );
  const doesIncludeFeeInOffer = organization.buyerConfig?.doesIncludeFeeInOffer;

  const [params, setParams] = useState({
    finalizedOffer: null,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedOffer) {
      // If this is that first time it happens
      if (!params._id) {
        reportEvent('offer_view', 'close');
      }
      setParams({ ...params, finalizedOffer: selectedOffer.finalizedOffer });
    }
  }, [selectedOffer]);

  if (!selectedOffer || Object.keys(selectedOffer).length === 0) return null;

  const handleClose = () => {
    reportEvent('offer_view', 'close');
    dispatch(setSelectedOffer());
    if (!type) {
      dispatch(push('/'));
    }
  };
  const title =
    selectedOffer?.dealSubmission?.lastCalculationParams?.propertyType ===
    PROPERTY_TYPE_LOT ? (
      <>
        ${selectedOffer?.dealSubmission?.address?.formattedAddress}{' '}
        <Tag color="orange">VACANT LOT</Tag>
      </>
    ) : (
      selectedOffer?.dealSubmission?.address?.formattedAddress
    );

  const isCustomMarketplace = Boolean(
    userDetails?.defaultOrganization?.marketplacePartner,
  );

  return (
    <Modal
      className="offer-modal"
      footer={null}
      width={isMobile() ? '100%' : 1100}
      visible={!!selectedOffer}
      onCancel={handleClose}
    >
      <div className="modal-header">
        <h3>{title}</h3>
        <div className="offer-status">
          <Tag>{DEAL_SUBMISSION_MATCH_STATUS_TITLES[selectedOffer.status]}</Tag>
        </div>
      </div>

      <Tabs
        type="card"
        className="secondary-tabs"
        onTabClick={(e) => reportEvent('offer_view', `tab_${e}`)}
      >
        <Tabs.TabPane tab="Offer status" key="offerStatus">
          <ActivityTab type={type} />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Property details" key="propertyDetails">
          <PropertyDetailsTab
            selectedOffer={selectedOffer}
            doesIncludeFeeInOffer={doesIncludeFeeInOffer}
            isCustomMarketplace={isCustomMarketplace}
          />
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  );
};
